import { useEffect, useState } from 'react';

import { isPageReachBottom } from '@/utils/Util';

export const useLocationScroll = ({ containerRef, onLoadMore, hasMore = true, debounceTime = 200 }) => {
	const [isLoadingMore, setIsLoadingMore] = useState(false);

	useEffect(() => {
		const scrollElement = containerRef?.current;
		let timeoutId;

		const handleScroll = () => {
			if (timeoutId) clearTimeout(timeoutId);

			timeoutId = setTimeout(() => {
				const isBottom = isPageReachBottom(containerRef.current);

				if (isBottom && !isLoadingMore && hasMore) {
					setIsLoadingMore(true);
					onLoadMore().finally(() => {
						setIsLoadingMore(false);
					});
				}
			}, debounceTime);
		};

		if (scrollElement) {
			scrollElement.addEventListener('scroll', handleScroll);
		}

		return () => {
			if (scrollElement) {
				scrollElement.removeEventListener('scroll', handleScroll);
			}
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, [containerRef, onLoadMore, isLoadingMore, hasMore, debounceTime]);

	return { isLoadingMore };
};
